import { AppConfigurator } from '@/app/layout/components/app.configurator';
import { LayoutService } from '@/app/layout/service/layout.service';
import { LazyImageWidget } from '@/app/pages/landing/components/lazyimagewidget';
import { Component, computed, inject } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-notfound',
    standalone: true,
    imports: [LazyImageWidget, RouterModule, AppConfigurator],
    template: ` <section class="animate-fadein animate-duration-300 animate-ease-in landing-container mx-auto min-h-[75vh] lg:min-h-screen flex flex-col items-center justify-center">
            <app-lazy-image-widget className="w-64 lg:w-96" [src]="'/demo/images/landing/' + (isDarkTheme() ? '404-dark.png' : '404.png')" alt="404 Image" />
            <h1 class="title-h5 lg:title-h1 mt-8">Error</h1>
            <p class="body-small lg:body-large mt-2 lg:mt-4">Something gone wrong!</p>
            <a routerLink="/" class="body-button bg-red-600 w-fit mt-8 hover:bg-red-500 px-4">Go to Dashboard</a>
        </section>
        <button class="layout-config-button config-link" (click)="layoutService.toggleConfigSidebar()">
            <i class="pi pi-cog"></i>
        </button>
        <app-configurator simple />`
})
export class Notfound {
    layoutService = inject(LayoutService);

    isDarkTheme = computed(() => this.layoutService.isDarkTheme());
}
